import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  Autocomplete,
} from "@react-google-maps/api";
import { countryCodes, RoutesPaths } from "../Router/constant";
import { createOrder } from "../Services/bookingService";
import { toast } from "react-toastify";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import axios from "axios";
import { getUserById } from "../Services/userService";

const containerStyle = {
  width: "100%",
  height: "200px",
  borderRadius: "4px",
};

const logisticsTypeMap = {
  "Air freight": 1,
  "Sea freight": 2,
  "Rail freight": 3,
  Trucking: 4,
};

const libraries = ["places"];

const styles = {
  container: {
    padding: 20,
  },

  loaderWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  loader: {
    width: "16px",
    height: "16px",
    border: "2px solid #fff",
    borderTop: "2px solid transparent",
    borderRadius: "50%",
    animation: "spin 0.6s linear infinite",
  },

  loaderText: {
    marginLeft: "8px",
    color: "#fff",
    fontSize: "14px",
  },

  heading: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "12px",
    color: "#333",
  },

  /* ===========================
     PHONE WRAPPER
  =========================== */

  phoneWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: 6,
    overflow: "visible",
    backgroundColor: "#fff",
  },

  countryDropdown: {
    position: "relative",
    display: "flex",
    alignItems: "stretch",
    minWidth: 150,
    background: "#fff",
  },

  countryTrigger: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    cursor: "pointer",
  },

  countrySelected: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    paddingLeft: 10,
    whiteSpace: "nowrap",
  },

  countryFlag: {
    width: 20,
    height: 15,
    objectFit: "cover",
    borderRadius: 2,
    flexShrink: 0,
  },

  countryText: {
    fontSize: 13,
    color: "#333",
    whiteSpace: "nowrap",
  },

  /* Arrow first, separator after arrow */
  arrow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 10px",
    marginLeft: 8,
    borderRight: "1px solid #ddd",
    flexShrink: 0,
  },

  /* ===========================
     DROPDOWN
  =========================== */

  dropdownMenu: {
    position: "absolute",
    top: "calc(100% + 5px)",
    left: 0,
    width: 280,
    maxWidth: "90vw",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: 8,
    zIndex: 99999,
    overflow: "hidden",
    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
  },

  /* ===========================
     SEARCH
  =========================== */

  countrySearchSection: {
    padding: 8,
    backgroundColor: "#fff",
    borderBottom: "1px solid #eee",
  },

  countrySearchBox: {
    height: 38,
    display: "flex",
    alignItems: "center",
    gap: 7,
    padding: "0 9px",
    border: "1px solid #ddd",
    borderRadius: 6,
    backgroundColor: "#f8f8f8",
  },

  countrySearchInput: {
    flex: 1,
    width: "100%",
    minWidth: 0,
    height: "100%",
    padding: 0,
    border: "none",
    outline: "none",
    background: "transparent",
    color: "#333",
    fontSize: 13,
  },

  countrySearchClear: {
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    color: "#777",
    fontSize: 20,
    lineHeight: 1,
    cursor: "pointer",
  },

  countryList: {
    maxHeight: 230,
    overflowY: "auto",
    overflowX: "hidden",
  },

  dropdownItem: {
    width: "100%",
    minHeight: 45,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    padding: "7px 10px",
    cursor: "pointer",
    boxSizing: "border-box",
    backgroundColor: "#fff",
  },

  dropdownItemSelected: {
    backgroundColor: "#f5f6f7",
  },

  countryItemLeft: {
    display: "flex",
    alignItems: "center",
    gap: 9,
    minWidth: 0,
  },

  countryItemDetails: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },

  countryName: {
    color: "#222",
    fontSize: 12,
    fontWeight: "500",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  countryItemCode: {
    color: "#666",
    fontSize: 12,
    whiteSpace: "nowrap",
  },

  countryCheck: {
    color: "#333",
    fontSize: 14,
    flexShrink: 0,
  },

  countryNoResult: {
    padding: "20px 12px",
    color: "#888",
    fontSize: 12,
    textAlign: "center",
  },

  phoneInput: {
    flex: 1,
    minWidth: 0,
    padding: "10px",
    border: "none",
    outline: "none",
    fontSize: 14,
  },

  form: {
    backgroundColor: "#fff",
    padding: "30px 25px",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    overflow: "visible",
    marginBottom: 30,
  },

  halfRow: {
    flex: 1,
    display: "flex",
    gap: 10,
  },

  tabContainer: {
    display: "flex",
    gap: 10,
    marginBottom: 20,
  },

  tab: {
    padding: "0px 20px",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14,
    transition: "0.3s",
    height: 35,
  },

  row: {
    display: "flex",
    gap: 15,
    marginBottom: 25,
  },

  box: {
    flex: 1,
  },

  label: {
    fontSize: 14,
    marginBottom: 5,
    display: "block",
    fontWeight: "500",
  },

  mapBox: {
    height: 120,
    backgroundColor: "#eaeaea",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#777",
    fontSize: 13,
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: 6,
    border: "1px solid #ddd",
    fontSize: 14,
  },

  optionBtn: {
    padding: "8px 14px",
    marginRight: 10,
    borderRadius: 6,
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    cursor: "pointer",
  },

  submitBtn: {
    backgroundColor: "#ff4d2d",
    color: "#fff",
    padding: "10px 25px",
    border: "none",
    borderRadius: 6,
    fontSize: 16,
    cursor: "pointer",
  },
};

export default function AddOrder() {
  const pickupAutoRef = useRef(null);
  const dropAutoRef = useRef(null);
  const countryRef = useRef(null);

  const navigate = useNavigate();
  const { userId } = useParams();

  const [singleUserData, setSingleUserData] = useState(null);
  const [submitLoader, setSubmitLoader] = useState(false);

  /*
   * =========================================
   * COUNTRY
   * =========================================
   */

  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const [countrySearch, setCountrySearch] = useState("");

  const getDefaultCountry = () =>
    countryCodes.find((country) => country.code === "AO") ||
    countryCodes.find((country) => country.dial_code === "+244") ||
    countryCodes[0];

  /*
   * Default = Angola
   */
  const [selectedCountry, setSelectedCountry] = useState(
    getDefaultCountry(),
  );

  /*
   * Search by:
   * Angola
   * AO
   * +244
   */
  const filteredCountries = countryCodes.filter((country) => {
    const search = String(countrySearch || "")
      .trim()
      .toLowerCase();

    if (!search) {
      return true;
    }

    const countryName = String(
      country.name ||
        country.country ||
        country.label ||
        "",
    ).toLowerCase();

    const countryCode = String(country.code || "").toLowerCase();

    const dialCode = String(country.dial_code || "").toLowerCase();

    return (
      countryName.includes(search) ||
      countryCode.includes(search) ||
      dialCode.includes(search)
    );
  });

  /*
   * =========================================
   * PRODUCT CONFIRM
   * =========================================
   */

  const [productChecked, setProductChecked] = useState(false);

  /*
   * =========================================
   * USER DATA
   * =========================================
   */

  useEffect(() => {
    if (userId) {
      fetchUserData();
    }
  }, [userId]);

  const fetchUserData = async () => {
    try {
      const usersResp = await getUserById(userId);

      const user = usersResp?.data?.data?.user;

      setSingleUserData(user);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  /*
   * =========================================
   * ADDRESS DETAILS
   * =========================================
   */

  const [pickupDetails, setPickupDetails] = useState({
    house: "",
    city: "",
    zipcode: "",
  });

  const [dropDetails, setDropDetails] = useState({
    house: "",
    city: "",
    zipcode: "",
  });

  /*
   * =========================================
   * USER DETAILS
   * =========================================
   */

  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    accountType: "personal",
  });

  /*
   * =========================================
   * MAP DATA
   * =========================================
   */

  const [pickupLocation, setPickupLocation] = useState(null);
  const [dropLocation, setDropLocation] = useState(null);

  const [pickupAddress, setPickupAddress] = useState("");
  const [dropAddress, setDropAddress] = useState("");

  /*
   * =========================================
   * PHONE
   * =========================================
   */

  const [formData, setFormData] = useState({
    phoneNumber: "",
  });

  /*
   * =========================================
   * PRODUCTS
   * =========================================
   */

  const [products, setProducts] = useState([
    {
      itemName: "",
      quantity: "",
      weight: "",
      height: "",
      heightUnit: "cm",
      width: "",
      widthUnit: "cm",
      previewImage: "",
      uploadedImage: "",
      uploading: false,
    },
  ]);

  /*
   * =========================================
   * RESET FORM
   * =========================================
   */

  const resetForm = () => {
    setPickupLocation(null);
    setDropLocation(null);

    setPickupAddress("");
    setDropAddress("");

    setPickupDetails({
      house: "",
      city: "",
      zipcode: "",
    });

    setDropDetails({
      house: "",
      city: "",
      zipcode: "",
    });

    setFormData({
      phoneNumber: "",
    });

    setUserDetails({
      name: "",
      email: "",
      accountType: "personal",
    });

    /*
     * Reset country back to AO
     */
    setSelectedCountry(getDefaultCountry());
    setCountrySearch("");
    setIsCountryOpen(false);

    setProducts([
      {
        itemName: "",
        quantity: "",
        weight: "",
        height: "",
        heightUnit: "cm",
        width: "",
        widthUnit: "cm",
        previewImage: "",
        uploadedImage: "",
        uploading: false,
      },
    ]);

    setPickupDate(null);
    setProductChecked(false);
  };

  /*
   * =========================================
   * FILE UPLOAD
   * =========================================
   */

  const uploadSingleFile = async (payload) => {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/upload/uploadbase4`,
      payload,
    );
  };

  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];

    if (!file || !file.type.startsWith("image/")) {
      return;
    }

    try {
      setProducts((prev) =>
        prev.map((product, i) =>
          i === index
            ? {
                ...product,
                uploading: true,
              }
            : product,
        ),
      );

      const reader = new FileReader();

      const base64 = await new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      const response = await uploadSingleFile({
        base64,
      });

      setProducts((prev) =>
        prev.map((product, i) =>
          i === index
            ? {
                ...product,
                previewImage: base64,
                uploadedImage:
                  response?.data?.data?.fileName || "",
                uploading: false,
              }
            : product,
        ),
      );
    } catch (err) {
      console.error(err);

      setProducts((prev) =>
        prev.map((product, i) =>
          i === index
            ? {
                ...product,
                uploading: false,
              }
            : product,
        ),
      );
    }
  };

  const handleRemoveImage = (index) => {
    setProducts((prev) =>
      prev.map((product, i) =>
        i === index
          ? {
              ...product,
              previewImage: "",
              uploadedImage: "",
            }
          : product,
      ),
    );
  };

  const removeProduct = (index) => {
    const updated = products.filter((_, i) => i !== index);

    setProducts(updated);
  };

  /*
   * =========================================
   * LOGISTICS
   * =========================================
   */

  const [selectedMode, setSelectedMode] = useState("Air freight");

  const [pickupDate, setPickupDate] = useState(null);

  const modes = [
    "Air freight",
    "Sea freight",
    "Rail freight",
    "Trucking",
  ];

  /*
   * =========================================
   * GOOGLE MAPS
   * =========================================
   */

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey:
      "AIzaSyBk6NKU8aUcbaQgqNJlGgh9ARAG6q5PkrA",
    libraries,
  });

  const defaultCenter = {
    lat: 28.6139,
    lng: 77.209,
  };

  /*
   * =========================================
   * COUNTRY SELECT
   * =========================================
   */

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);

    setIsCountryOpen(false);

    setCountrySearch("");
  };

  /*
   * =========================================
   * COUNTRY OUTSIDE CLICK
   * =========================================
   */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryRef.current &&
        !countryRef.current.contains(event.target)
      ) {
        setIsCountryOpen(false);
        setCountrySearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside,
      );
    };
  }, []);

  /*
   * =========================================
   * REVERSE GEOCODE
   * =========================================
   */

  const reverseGeocode = async (lat, lng) => {
    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve, reject) => {
      geocoder.geocode(
        {
          location: {
            lat,
            lng,
          },
        },
        (results, status) => {
          if (status === "OK" && results[0]) {
            resolve(results[0].formatted_address);
          } else {
            reject("No address found");
          }
        },
      );
    });
  };

  /*
   * =========================================
   * PHONE INPUT CHANGE
   * =========================================
   */

  const handleChange = (e) => {
    const { name, value } = e.target;

    const finalValue =
      name === "phoneNumber"
        ? value.replace(/\D/g, "")
        : value;

    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
  };

  /*
   * =========================================
   * PRODUCT CHANGE
   * =========================================
   */

  const handleProductChange = (index, field, value) => {
    const updated = [...products];

    updated[index][field] = value;

    setProducts(updated);
  };

  const addProduct = () => {
    setProducts([
      ...products,
      {
        itemName: "",
        quantity: "",
        weight: "",
        height: "",
        heightUnit: "cm",
        width: "",
        widthUnit: "cm",
        previewImage: "",
        uploadedImage: "",
        uploading: false,
      },
    ]);
  };

  /*
   * =========================================
   * EMAIL VALIDATE
   * =========================================
   */

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  /*
   * =========================================
   * SUBMIT
   * =========================================
   */

  const handleSubmit = async () => {
    if (!pickupLocation || !pickupAddress) {
      toast.error("Please select pickup location");
      return;
    }

    if (!dropLocation || !dropAddress) {
      toast.error("Please select drop location");
      return;
    }

    if (!userDetails.name) {
      toast.error("Please enter name");
      return;
    }

    if (!formData.phoneNumber) {
      toast.error("Please enter phone number");
      return;
    }

    if (!userDetails.email) {
      toast.error("Please enter email");
      return;
    }

    if (!validateEmail(userDetails.email)) {
      toast.error("Enter valid email");
      return;
    }

    if (!pickupDate) {
      toast.error("Please select pickup date");
      return;
    }

    if (!productChecked) {
      toast.error(
        "Please confirm product details checkbox",
      );

      return;
    }

    if (products.length === 0) {
      toast.error("Add at least one product");
      return;
    }

    for (let i = 0; i < products.length; i++) {
      const product = products[i];

      const quantity = Number(product.quantity);
      const weight = Number(product.weight);

      if (
        !product.itemName.trim() ||
        !product.quantity ||
        !product.weight
      ) {
        toast.error(
          `Fill all product fields (${i + 1})`,
        );

        return;
      }

      if (!product.uploadedImage) {
        toast.error(
          `Please upload image for product (${i + 1})`,
        );

        return;
      }

      if (isNaN(quantity) || isNaN(weight)) {
        toast.error(
          `Quantity & Weight must be numbers (${i + 1})`,
        );

        return;
      }

      if (quantity <= 0 || weight <= 0) {
        toast.error(
          `Quantity & Weight must be greater than 0 (${i + 1})`,
        );

        return;
      }
    }

    const formattedDate = pickupDate
      ? pickupDate.toISOString().split("T")[0]
      : null;

    const payload = {
      userId,

      logisticsType:
        logisticsTypeMap[selectedMode] || 1,

      pickupAddress: {
        address: pickupAddress,

        pickupHousenoStno: pickupDetails.house,

        pickupCity: pickupDetails.city,

        pickupZipcode: pickupDetails.zipcode,

        longitude: pickupLocation?.lng || "",

        latitude: pickupLocation?.lat || "",
      },

      dropAddress: {
        address: dropAddress,

        dropHousenoStno: dropDetails.house,

        dropCity: dropDetails.city,

        dropZipcode: dropDetails.zipcode,

        longitude: dropLocation?.lng || "",

        latitude: dropLocation?.lat || "",
      },

      /*
       * Default AO = +244
       */
      countryCode:
        selectedCountry?.dial_code || "+244",

      phoneNumber: formData.phoneNumber,

      name: userDetails.name,

      accountType: userDetails.accountType,

      email: userDetails.email,

      estimatedCharges: "100",

      productDetails: products.map((product) => ({
        name: product.itemName,

        quantity: product.quantity,

        weight: product.weight,

        width: product.width,

        widthOption: product.widthUnit,

        height: product.height,

        heightOption: product.heightUnit,

        image: product.uploadedImage,
      })),

      description: "",

      currency: "AOA",

      questions: [],

      signedDocument: "",

      alternatePhone: "",

      pickupTime: "",

      date: formattedDate,
    };

    try {
      setSubmitLoader(true);

      const response = await createOrder(payload);

      if (
        response?.status === 200 &&
        response?.data?.status
      ) {
        toast.success("Order created successfully");

        resetForm();

        navigate("/booking-management");
      } else {
        toast.error("Submission failed");
      }
    } catch (error) {
      console.error("Submit error:", error);

      toast.error("Something went wrong");
    } finally {
      setSubmitLoader(false);
    }
  };

  /*
   * =========================================
   * CURRENT LOCATION
   * =========================================
   */

  useEffect(() => {
    if (!isLoaded) return;

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        const location = {
          lat,
          lng,
        };

        setPickupLocation(location);
        setDropLocation(location);

        try {
          const address = await reverseGeocode(lat, lng);

          setPickupAddress(address);

          setDropAddress(address);
        } catch (err) {
          console.warn(err);
        }
      },

      (error) => {
        console.warn(
          "Geolocation denied or failed",
          error,
        );

        setPickupLocation(defaultCenter);

        setDropLocation(defaultCenter);
      },
    );
  }, [isLoaded]);

  const userDisplayName = singleUserData
    ? `${singleUserData.fullName || ""}`.trim()
    : "";

  return (
    <div style={styles.container}>
      {/* ===================================== */}
      {/* BREADCRUMB */}
      {/* ===================================== */}

      <div className="logisticsMenu">
        <p>
          <NavLink to={RoutesPaths.DASHBOARD}>
            <img
              src="/assets/img/homeIcon.svg"
              alt=""
            />
          </NavLink>
        </p>

        <img
          src="/assets/img/chevron-right.svg"
          alt=""
        />

        <p>
          <NavLink to={RoutesPaths.USERMANAGEMENT}>
            User management
          </NavLink>
        </p>
      </div>

      {userDisplayName && (
        <p
          style={{
            fontSize: 13,
            color: "#777",
            marginTop: 4,
          }}
        >
          Order creating for:{" "}
          <strong>{userDisplayName}</strong>
        </p>
      )}

      {/* ===================================== */}
      {/* LOGISTICS */}
      {/* ===================================== */}

      <div style={{ marginTop: "20px" }}>
        <h3 style={styles.heading}>
          Select Logistic Type
        </h3>

        <div style={styles.tabContainer}>
          {modes.map((mode) => (
            <button
              type="button"
              key={mode}
              onClick={() => setSelectedMode(mode)}
              style={{
                ...styles.tab,

                backgroundColor:
                  selectedMode === mode
                    ? "#ff4d2d"
                    : "#f5f5f5",

                color:
                  selectedMode === mode
                    ? "#fff"
                    : "#333",

                border:
                  selectedMode === mode
                    ? "2px solid #ff4d2d"
                    : "1px solid #ddd",
              }}
            >
              {mode}
            </button>
          ))}
        </div>
      </div>

      {/* ===================================== */}
      {/* ADDRESS / USER FORM */}
      {/* ===================================== */}

      <div style={styles.form}>
        <div
          style={{
            ...styles.row,
            marginBottom: 10,
          }}
        >
          {/* PICKUP */}

          <div style={styles.box}>
            <label style={styles.label}>
              Pickup address *
            </label>

            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={pickupLocation || defaultCenter}
                zoom={14}
                onClick={async (e) => {
                  const lat = e.latLng.lat();
                  const lng = e.latLng.lng();

                  setPickupLocation({
                    lat,
                    lng,
                  });

                  try {
                    const address =
                      await reverseGeocode(lat, lng);

                    setPickupAddress(address);
                  } catch (err) {
                    console.warn(err);
                  }
                }}
              >
                {pickupLocation && (
                  <Marker
                    position={pickupLocation}
                    draggable
                    onDragEnd={async (e) => {
                      const lat = e.latLng.lat();
                      const lng = e.latLng.lng();

                      setPickupLocation({
                        lat,
                        lng,
                      });

                      try {
                        const address =
                          await reverseGeocode(
                            lat,
                            lng,
                          );

                        setPickupAddress(address);
                      } catch (err) {
                        console.warn(err);
                      }
                    }}
                  />
                )}
              </GoogleMap>
            ) : (
              <p>Loading Map...</p>
            )}

            {isLoaded && (
              <Autocomplete
                onLoad={(ref) =>
                  (pickupAutoRef.current = ref)
                }
                onPlaceChanged={() => {
                  const place =
                    pickupAutoRef.current.getPlace();

                  if (!place.geometry) return;

                  const lat =
                    place.geometry.location.lat();

                  const lng =
                    place.geometry.location.lng();

                  setPickupLocation({
                    lat,
                    lng,
                  });

                  setPickupAddress(
                    place.formatted_address || "",
                  );
                }}
              >
                <input
                  type="text"
                  placeholder="Search pickup location"
                  value={pickupAddress}
                  onChange={(e) =>
                    setPickupAddress(e.target.value)
                  }
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginBottom: "8px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                  }}
                />
              </Autocomplete>
            )}
          </div>

          {/* DROP */}

          <div style={styles.box}>
            <label style={styles.label}>
              Drop address *
            </label>

            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={dropLocation || defaultCenter}
                zoom={14}
                onClick={async (e) => {
                  const lat = e.latLng.lat();
                  const lng = e.latLng.lng();

                  setDropLocation({
                    lat,
                    lng,
                  });

                  try {
                    const address =
                      await reverseGeocode(lat, lng);

                    setDropAddress(address);
                  } catch (err) {
                    console.warn(err);
                  }
                }}
              >
                {dropLocation && (
                  <Marker
                    position={dropLocation}
                    draggable
                    onDragEnd={async (e) => {
                      const lat = e.latLng.lat();
                      const lng = e.latLng.lng();

                      setDropLocation({
                        lat,
                        lng,
                      });

                      try {
                        const address =
                          await reverseGeocode(
                            lat,
                            lng,
                          );

                        setDropAddress(address);
                      } catch (err) {
                        console.warn(err);
                      }
                    }}
                  />
                )}
              </GoogleMap>
            ) : (
              <p>Loading Map...</p>
            )}

            {isLoaded && (
              <Autocomplete
                onLoad={(ref) =>
                  (dropAutoRef.current = ref)
                }
                onPlaceChanged={() => {
                  const place =
                    dropAutoRef.current.getPlace();

                  if (!place.geometry) return;

                  const lat =
                    place.geometry.location.lat();

                  const lng =
                    place.geometry.location.lng();

                  setDropLocation({
                    lat,
                    lng,
                  });

                  setDropAddress(
                    place.formatted_address || "",
                  );
                }}
              >
                <input
                  type="text"
                  placeholder="Search drop location"
                  value={dropAddress}
                  onChange={(e) =>
                    setDropAddress(e.target.value)
                  }
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginBottom: "8px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                  }}
                />
              </Autocomplete>
            )}
          </div>
        </div>

        {/* ADDRESS REMAINING */}

        <div
          style={{
            ...styles.row,
            marginBottom: 30,
          }}
        >
          <div style={styles.halfRow}>
            <input
              style={styles.input}
              placeholder="Address remaining details"
              value={pickupDetails.house}
              onChange={(e) =>
                setPickupDetails({
                  ...pickupDetails,
                  house: e.target.value,
                })
              }
            />
          </div>

          <div style={styles.halfRow}>
            <input
              style={styles.input}
              placeholder="Address remaining details"
              value={dropDetails.house}
              onChange={(e) =>
                setDropDetails({
                  ...dropDetails,
                  house: e.target.value,
                })
              }
            />
          </div>
        </div>

        {/* ===================================== */}
        {/* CONTACT */}
        {/* ===================================== */}

        <div
          style={{
            ...styles.row,
            marginBottom: 30,
          }}
        >
          {/* ================================== */}
          {/* PHONE + SEARCHABLE COUNTRY */}
          {/* ================================== */}

          <div style={styles.phoneWrapper}>
            <div
              style={styles.countryDropdown}
              ref={countryRef}
            >
              {/* TRIGGER */}

              <div
                style={styles.countryTrigger}
                onClick={() => {
                  setIsCountryOpen((prev) => !prev);

                  if (isCountryOpen) {
                    setCountrySearch("");
                  }
                }}
              >
                <div style={styles.countrySelected}>
                  <img
                    src={`https://flagcdn.com/24x18/${selectedCountry.code.toLowerCase()}.png`}
                    alt={selectedCountry.code}
                    style={styles.countryFlag}
                  />

                  <span style={styles.countryText}>
                    {selectedCountry.dial_code} (
                    {selectedCountry.code})
                  </span>
                </div>

                {/* ARROW -> LINE */}

                <span style={styles.arrow}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    style={{
                      transform: isCountryOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",

                      transition:
                        "transform 0.2s ease",
                    }}
                  >
                    <path
                      d="M7 10l5 5 5-5"
                      stroke="#555"
                      strokeWidth="1.6"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>

              {/* ================================== */}
              {/* DROPDOWN */}
              {/* ================================== */}

              {isCountryOpen && (
                <div
                  style={styles.dropdownMenu}
                  onClick={(e) =>
                    e.stopPropagation()
                  }
                >
                  {/* SEARCH */}

                  <div
                    style={styles.countrySearchSection}
                  >
                    <div
                      style={styles.countrySearchBox}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <circle
                          cx="11"
                          cy="11"
                          r="7"
                          stroke="#777"
                          strokeWidth="1.7"
                        />

                        <path
                          d="M16.2 16.2L21 21"
                          stroke="#777"
                          strokeWidth="1.7"
                          strokeLinecap="round"
                        />
                      </svg>

                      <input
                        type="text"
                        value={countrySearch}
                        autoFocus
                        placeholder="Search country or code"
                        style={
                          styles.countrySearchInput
                        }
                        onClick={(e) =>
                          e.stopPropagation()
                        }
                        onChange={(e) =>
                          setCountrySearch(
                            e.target.value,
                          )
                        }
                      />

                      {countrySearch && (
                        <button
                          type="button"
                          style={
                            styles.countrySearchClear
                          }
                          onClick={(e) => {
                            e.stopPropagation();

                            setCountrySearch("");
                          }}
                        >
                          ×
                        </button>
                      )}
                    </div>
                  </div>

                  {/* COUNTRY LIST */}

                  <div style={styles.countryList}>
                    {filteredCountries.length > 0 ? (
                      filteredCountries.map(
                        (country) => {
                          const isSelected =
                            selectedCountry?.code ===
                            country.code;

                          return (
                            <div
                              key={`${country.code}-${country.dial_code}`}
                              style={{
                                ...styles.dropdownItem,

                                ...(isSelected
                                  ? styles.dropdownItemSelected
                                  : {}),
                              }}
                              onMouseEnter={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.backgroundColor =
                                    "#f5f5f5";
                                }
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  isSelected
                                    ? "#f5f6f7"
                                    : "#fff";
                              }}
                              onClick={(e) => {
                                e.stopPropagation();

                                handleCountrySelect(
                                  country,
                                );
                              }}
                            >
                              <div
                                style={
                                  styles.countryItemLeft
                                }
                              >
                                <img
                                  src={`https://flagcdn.com/24x18/${country.code.toLowerCase()}.png`}
                                  alt={country.code}
                                  style={
                                    styles.countryFlag
                                  }
                                />

                                <div
                                  style={
                                    styles.countryItemDetails
                                  }
                                >
                                  {(country.name ||
                                    country.country ||
                                    country.label) && (
                                    <span
                                      style={
                                        styles.countryName
                                      }
                                    >
                                      {country.name ||
                                        country.country ||
                                        country.label}
                                    </span>
                                  )}

                                  <span
                                    style={
                                      styles.countryItemCode
                                    }
                                  >
                                    {
                                      country.dial_code
                                    }{" "}
                                    ({country.code})
                                  </span>
                                </div>
                              </div>

                              {isSelected && (
                                <span
                                  style={
                                    styles.countryCheck
                                  }
                                >
                                  ✓
                                </span>
                              )}
                            </div>
                          );
                        },
                      )
                    ) : (
                      <div
                        style={
                          styles.countryNoResult
                        }
                      >
                        No country found
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* PHONE NUMBER */}

            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="Enter phone number *"
              style={styles.phoneInput}
              inputMode="numeric"
            />
          </div>

          {/* NAME */}

          <input
            style={styles.input}
            placeholder="Name *"
            value={userDetails.name}
            onChange={(e) =>
              setUserDetails({
                ...userDetails,
                name: e.target.value,
              })
            }
          />
        </div>

        {/* DATE + EMAIL */}

        <div
          style={{
            ...styles.row,
            marginBottom: 30,
          }}
        >
          <DatePicker
            selected={pickupDate}
            onChange={(date) => setPickupDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Pickup date *"
            minDate={new Date()}
            customInput={
              <input
                style={styles.input}
                readOnly
              />
            }
          />

          <input
            style={styles.input}
            placeholder="Email *"
            value={userDetails.email}
            onChange={(e) =>
              setUserDetails({
                ...userDetails,
                email: e.target.value,
              })
            }
          />
        </div>

        {/* USER TYPE */}

        <div style={{ marginTop: 30 }}>
          <p style={styles.label}>
            What describes you best? *
          </p>

          <div>
            <button
              type="button"
              style={{
                ...styles.optionBtn,

                backgroundColor:
                  userDetails.accountType ===
                  "personal"
                    ? "#ff4d2d"
                    : "#fff",

                color:
                  userDetails.accountType ===
                  "personal"
                    ? "#fff"
                    : "#333",

                border:
                  userDetails.accountType ===
                  "personal"
                    ? "1px solid #ff4d2d"
                    : "1px solid #ddd",
              }}
              onClick={() =>
                setUserDetails({
                  ...userDetails,
                  accountType: "personal",
                })
              }
            >
              Personal user
            </button>

            <button
              type="button"
              style={{
                ...styles.optionBtn,

                backgroundColor:
                  userDetails.accountType ===
                  "business"
                    ? "#ff4d2d"
                    : "#fff",

                color:
                  userDetails.accountType ===
                  "business"
                    ? "#fff"
                    : "#333",

                border:
                  userDetails.accountType ===
                  "business"
                    ? "1px solid #ff4d2d"
                    : "1px solid #ddd",
              }}
              onClick={() =>
                setUserDetails({
                  ...userDetails,
                  accountType: "business",
                })
              }
            >
              Business user
            </button>
          </div>
        </div>
      </div>

      {/* ===================================== */}
      {/* PRODUCT FORM */}
      {/* ===================================== */}

      <div style={styles.form}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h3>Product attributes</h3>

            <p
              style={{
                fontSize: 13,
                color: "#777",
              }}
            >
              You can fill in the following product attributes to get a
              quotation within 24 hours
            </p>
          </div>
        </div>

        {products.map((product, index) => (
          <div
            key={index}
            style={{
              marginTop: 20,
            }}
          >
            {/* DELETE */}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {products.length > 1 && (
                <button
                  type="button"
                  onClick={() =>
                    removeProduct(index)
                  }
                  style={{
                    background: "red",
                    color: "#fff",
                    border: "none",
                    padding: "5px 10px",
                    borderRadius: 5,
                    cursor: "pointer",
                    marginBottom: 5,
                  }}
                >
                  Delete
                </button>
              )}
            </div>

            <div
              style={{
                display: "flex",
                gap: 20,
              }}
            >
              {/* UPLOAD */}

              <div
                style={{
                  width: 140,
                  height: 140,
                  border: "1px solid #ddd",
                  borderRadius: 10,
                  position: "relative",
                  cursor: "pointer",
                  overflow: "hidden",
                }}
                onClick={() => {
                  if (!product.uploading) {
                    document
                      .getElementById(
                        `file-${index}`,
                      )
                      ?.click();
                  }
                }}
              >
                <img
                  src={
                    product.previewImage ||
                    "/assets/img/imageAdd.svg"
                  }
                  alt="upload"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />

                {product.uploading && (
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,

                      background:
                        "rgba(255,255,255,0.7)",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Loading...
                  </div>
                )}

                {product.previewImage &&
                  !product.uploading && (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();

                        handleRemoveImage(index);
                      }}
                      style={{
                        position: "absolute",
                        top: 5,
                        right: 5,
                        background: "red",
                        color: "#fff",
                        borderRadius: "50%",
                        width: 20,
                        height: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        fontSize: 12,
                      }}
                    >
                      ✕
                    </div>
                  )}
              </div>

              <input
                type="file"
                id={`file-${index}`}
                accept="image/*"
                style={{
                  display: "none",
                }}
                onChange={(e) =>
                  handleFileChange(e, index)
                }
              />

              {/* PRODUCT FIELDS */}

              <div style={{ flex: 1 }}>
                <div style={styles.row}>
                  <input
                    style={styles.input}
                    placeholder="Item name *"
                    value={product.itemName}
                    onChange={(e) =>
                      handleProductChange(
                        index,
                        "itemName",
                        e.target.value,
                      )
                    }
                  />

                  <input
                    style={styles.input}
                    placeholder="Quantity *"
                    value={product.quantity}
                    onChange={(e) =>
                      handleProductChange(
                        index,
                        "quantity",
                        e.target.value.replace(
                          /\D/g,
                          "",
                        ),
                      )
                    }
                  />
                </div>

                <div style={styles.row}>
                  <input
                    style={styles.input}
                    placeholder="Weight (kg) *"
                    value={product.weight}
                    onChange={(e) =>
                      handleProductChange(
                        index,
                        "weight",
                        e.target.value.replace(
                          /[^0-9.]/g,
                          "",
                        ),
                      )
                    }
                  />

                  {/* HEIGHT */}

                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <input
                      style={{
                        ...styles.input,
                        paddingRight: "60px",
                      }}
                      placeholder="Height"
                      value={product.height}
                      onChange={(e) =>
                        handleProductChange(
                          index,
                          "height",
                          e.target.value.replace(
                            /\D/g,
                            "",
                          ),
                        )
                      }
                    />

                    <select
                      value={product.heightUnit}
                      onChange={(e) =>
                        handleProductChange(
                          index,
                          "heightUnit",
                          e.target.value,
                        )
                      }
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        transform:
                          "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        fontSize: 14,
                        cursor: "pointer",
                        outline: "none",
                      }}
                    >
                      <option value="cm">
                        cm
                      </option>

                      <option value="mm">
                        mm
                      </option>

                      <option value="inch">
                        inch
                      </option>

                      <option value="meter">
                        meter
                      </option>

                      <option value="feet">
                        feet
                      </option>
                    </select>
                  </div>
                </div>

                {/* WIDTH */}

                <div style={styles.row}>
                  <div
                    style={{
                      position: "relative",
                      width: "50%",
                    }}
                  >
                    <input
                      style={{
                        ...styles.input,
                        paddingRight: "60px",
                      }}
                      placeholder="Width"
                      value={product.width}
                      onChange={(e) =>
                        handleProductChange(
                          index,
                          "width",
                          e.target.value.replace(
                            /\D/g,
                            "",
                          ),
                        )
                      }
                    />

                    <select
                      value={product.widthUnit}
                      onChange={(e) =>
                        handleProductChange(
                          index,
                          "widthUnit",
                          e.target.value,
                        )
                      }
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        transform:
                          "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        fontSize: 14,
                        cursor: "pointer",
                        outline: "none",
                      }}
                    >
                      <option value="cm">
                        cm
                      </option>

                      <option value="mm">
                        mm
                      </option>

                      <option value="inch">
                        inch
                      </option>

                      <option value="meter">
                        meter
                      </option>

                      <option value="feet">
                        feet
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* ADD PRODUCT */}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            style={styles.submitBtn}
            onClick={addProduct}
          >
            + Add more product
          </button>
        </div>

        {/* DETAILS */}

        <div style={{ marginTop: 20 }}>
          <p style={styles.label}>
            Detailed requirements
          </p>

          <textarea
            style={{
              width: "100%",
              height: 120,
              borderRadius: 6,
              border: "1px solid #ddd",
              padding: 10,
            }}
            placeholder="Please type in..."
          />
        </div>

        {/* CONFIRM */}

        <div style={{ marginTop: 15 }}>
          <input
            type="checkbox"
            checked={productChecked}
            onChange={(e) =>
              setProductChecked(
                e.target.checked,
              )
            }
          />

          <span
            style={{
              marginLeft: 8,
              fontSize: 14,
            }}
          >
            I hereby confirm that the product details provided are accurate
            and correct.
          </span>
        </div>

        {/* SUBMIT */}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 30,
          }}
        >
          <button
            type="button"
            style={styles.submitBtn}
            onClick={handleSubmit}
            disabled={submitLoader}
          >
            {submitLoader ? (
              <span style={styles.loaderWrapper}>
                <span style={styles.loader}></span>

                <span style={styles.loaderText}>
                  Submitting...
                </span>
              </span>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}